import VerifiedUserPerks from "./VerifiedUserPerks";
import VerifiedUserBadge from "./VerifiedUserBadge";
import Link from "next/link";

export default function UserVerified({
  idVerified,
  idNumber,
}: {
  idVerified?: boolean;
  idNumber?: string;
}) {
  return (
    <div className="w-full rounded-lg bg-white shadow-sm border border-gray-200">
      <div className="px-4 py-5 sm:px-6">
        <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
          <div className="ml-4 mt-2 space-y-1">
            <div className="flex items-center space-x-2">
              <VerifiedUserBadge idVerified={idVerified} />
              <h3 className="text-lg font-medium leading-6 text-gray-900">
                {idVerified
                  ? "Identidad verificada"
                  : "No has verificado tu identidad"}
              </h3>
              {idVerified && idNumber ? (
                <p className="text-gray-700">{idNumber}</p>
              ) : null}
            </div>

            <div className="pb-2 px-2">
              {!idVerified ? (
                <h3 className="mt-3 text-xs font-medium text-gray-900 tracking-wide uppercase">
                  ¿Por qué verificar tu identidad?
                </h3>
              ) : null}
              <VerifiedUserPerks idVerified={idVerified} />
            </div>
          </div>
        </div>
        {!idVerified ? (
          <div className="flex justify-end mt-2">
            <Link href="/profile/edit" target="_blank">
              <span className="ml-3 inline-flex gap-x-1 justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-orange-500 hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 disabled:opacity-50">
                Ir a verificar identidad
              </span>
            </Link>
          </div>
        ) : null}
      </div>
    </div>
  );
}
